<template>
    <div>
        <b-row v-if="!referentielView">
            <b-col>
                <b-form-group v-model="createNew">
                    <b-form-radio v-model="createNew" :value="false">
                        Ajouter un nouveau poste au référentiel à partir de la liste de Pôle Emploi
                    </b-form-radio>
                    <b-form-radio v-model="createNew" :value="true">
                        Proposer un nouveau poste au référentiel
                    </b-form-radio>
                </b-form-group>
            </b-col>
        </b-row>
        <b-form @submit="onSubmit" v-bind:validated="formSubmitted">
            <b-row v-if="!createNew">
                <b-col>
                    <b-form-group id="input-group-codeLibelle" class="w-100" label-for="input-codeLibelle">
                        <template v-slot:label>
                            <label-custom
                                    label="Code ROME ou intitulé du poste"
                                    tooltip="Entrer le code ROME ou les premiers caractères de l'intitulé du poste">
                            </label-custom>
                        </template>
                        <AutocompleteCustom
                                id="input-codeLibelle"
                                :items="codesRome"
                                v-model="code"
                                @search="search">
                        </AutocompleteCustom>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="createNew">
                <b-col>
                    <b-form-group id="input-group-code" label-for="input-code">
                        <template v-slot:label>
                            <label-custom
                                    label="Code ROME"
                                    tooltip="Le format d'un code ROME correspond à une lettre en majuscule suivie de 4 chiffres"
                                    :required="true">
                            </label-custom>
                        </template>
                        <b-form-input
                                id="input-code"
                                v-model="code.code"
                                type="text"
                                maxlength="5"
                                :pattern="regexCodeRome"
                                :trim="true"
                                required
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group id="input-group-libelle" label-for="input-libelle">
                        <template v-slot:label>
                            <label-custom
                                    label="Intitulé du poste"
                                    tooltip="Intitulé du poste"
                                    :required="true">
                            </label-custom>
                        </template>
                        <b-form-input
                                id="input-libelle"
                                v-model="code.libelle"
                                type="text"
                                maxlength="255"
                                :trim="true"
                                required
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="(code && code.id!= null ) || createNew">
                <b-col>
                    <b-form-group
                            id="input-group-type"
                            label-for="type">
                        <template v-slot:label>
                            <label-custom
                                    label="Typologie de poste"
                                    tooltip=""
                                    :required="true">
                            </label-custom>
                        </template>
                        <b-form-select
                                id="type"
                                v-model="code.type"
                                :options="typologies"
                                :disabled="typeDisabled"
                                required>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="pt-2" align-h="center">
                <b-button type="submit" variant="primary" @click="formSubmitted = true">
                    Valider
                </b-button>
            </b-row>
        </b-form>
    </div>
</template>

<script>

  import CodeRomeDto from "../../dtos/CodeRomeDto";
  import LabelCustom from "../../components/LabelCustom";
  import AutocompleteCustom from "../../components/AutocompleteCustom";
  import CodeRomeStore from "../../stores/CodeRomeStore";
  import {REGEX_CODE_ROME} from "../../constants/regex";
  import {TypologiePosteEnum} from "../../constants/enums";
  import AlertStore from "../../stores/AlertStore";

  export default {
    name: 'CreerCodeRome',
    components: {LabelCustom, AutocompleteCustom},
    props: {
      codeRome: {
        type: CodeRomeDto
      },
      referentielView: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        createNew: this.referentielView,
        typeDisabled: false,
        code: new CodeRomeDto(),
        codesRome: [],
        formSubmitted: false,
        regexCodeRome: REGEX_CODE_ROME,
        typologies: Object.entries(TypologiePosteEnum).map((value) => {
          return {text: value[1], value: value[0]};
        }),
      }
    },
    watch: {
      createNew() {
        if (this.createNew) {
          this.code = new CodeRomeDto();
        }
      },
      code() {
        this.typeDisabled = this.code && this.code.type != null;
      }
    },
    methods: {
      search(codeLibelle) {
        CodeRomeStore.getByCodeLibelle(codeLibelle).then(
            codes => {
              this.codesRome = codes.map(value => {
                return {text: `${value.code} - ${value.libelle}`, value: value};
              });
            }
        )
      },
      onSubmit(evt) {
        evt.preventDefault();
        if (this.createNew) {
          this.codeRome.code = this.code.code;
          this.codeRome.libelle = this.code.libelle;
          this.codeRome.type = this.code.type;
          if (this.referentielView) {
            this.code.presentSynthese = true;
          }
          CodeRomeStore.create(this.code).then(value => {
            if (value) {
              if (this.referentielView) {
                AlertStore.pushSuccess('Poste ajouté au référentiel avec succès.');
              }
              this.assignCodeAndClose(value);
            }
          });
        } else {
          CodeRomeStore.updateType(this.code.id, this.code.type).then(value => {
            if (value) {
              this.assignCodeAndClose(value);
            }
          });
        }
      },
      assignCodeAndClose(code) {
        this.code = code;
        for (const prop in this.code) {
          if (this.codeRome.hasOwnProperty(prop)) {
            this.codeRome[prop] = this.code[prop];
          }
        }
        this.$root.$emit('bv::hide::modal', 'modal-add-poste');
      }
    }
  }
</script>
